import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[appNumbersOnly]',
    standalone: false
})
export class NumbersOnlyDirective {

  constructor(private _el: ElementRef) { }

  @HostListener('input', ['$event']) onInputChange(event) {
    const initalValue = this._el.nativeElement.value;
    // Allow numbers and common phone formatting characters: spaces, dashes, parentheses, plus
    this._el.nativeElement.value = initalValue.replace(/[^0-9\s\-()+]*/g, '');
    if (initalValue !== this._el.nativeElement.value) {
      event.stopPropagation();
    }
  }

}
